<template lang="pug">
    div.dummy-cropper-control
        div.dummy-cropper-control__content
            slot
            resize-sensor(@resize='contentResize')
        canvas.dummy-cropper-control__canvas(ref='canvas' v-bind="canvasDimensions")
</template>

<script>
/*global _ */
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import {fv} from 'utils/vue/lib/utils'

export default {
    name: 'dummy-cropper-control',
    props: {
        value: {},
        aspectRatio: {
            type: [Number, String],
            default: null
        },
        // dimensions are provided to render the canvas with correct dimensions
        dimensions: {
            type: Object,
            default: () => ({})
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            innerValue: this.value,
            cropper: null,
            cropperReady: false,
            width: null,
            height: null
        }
    },
    computed: {
        canvasDimensions() {
            const dimensions = {
                width: fv(this.width, this.dimensions.width),
                height: fv(this.height, this.dimensions.height),
            }
            return _.omitBy(dimensions, v => _.isNil(v))
        },
        cropperOptions() {
            const options = {
                viewMode: 1,
                autoCropArea: 1,
                aspectRatio: this.aspectRatio || NaN,
                responsive: true,
                rotatable: false,
                zoomable: false,
                scalable: false,
                data: this.innerValue,
                minContainerWidth: 1,
                minContainerHeight: 1,
                minCanvasWidth: 1,
                minCanvasHeight: 1,
                ready: () => {
                    this.cropperReady = true
                    this.$emit('ready', this.cropper, this)
                },
                crop: (e) => {
                    const previousValue = _.cloneDeep(this.innerValue)
                    const data = this.innerValue = e.detail
                    const isNil = !data.x && !data.y && !data.height && !data.width
                    if (!isNil) {
                        this.$emit('input', data)
                        this.$emit('crop', data, previousValue, e, this.cropper, this)
                    }
                },
                ...this.options
            }
            return options
        }

    },
    watch: {
        aspectRatio(val) {
            if (this.cropperReady) {
                this.cropper.setAspectRatio(val || NaN)
            }
        },
    },

    mounted() {
        this.cropper = new Cropper(this.$refs.canvas, this.cropperOptions)
    },
    beforeDestroy() {
        this.cropper.destroy()
    },
    methods: {
        contentResize(e) {
            const {width, height} = e
            this.width = width
            this.height = height
            this.$emit('content:resized', e, this.cropper, this)
            if (this.cropperReady) {
                this.$emit('resized', e, this.cropper, this)
            }
        },
    },
}
</script>
